(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'keyDates', {
            bindings: {
                compactView:   '@',
                limit:         '@',
                onModelReady:  '&'
            },
            templateUrl:  'app/views/partials/content/key-dates.html',
            controller:   KeyDatesController,
            controllerAs: 'vm'
        })

        // Text-based (inline) version
        .component( 'keyDatesInline', {
            bindings:     {
                onModelReady:  '&',
                limit:         '@'
            },
            templateUrl:  'app/views/partials/content/key-dates-inline.html',
            controller:   KeyDatesController,
            controllerAs: 'vm'
        })

        // Simplified one-liner version
        .component( 'keyDatesSimplified', {
            bindings:     {
                onModelReady:  '&',
                limit:         '@'
            },
            templateUrl:  'app/views/partials/content/key-dates-simplified.html',
            controller:   KeyDatesController,
            controllerAs: 'vm'
        });


    /**
     * Lists out all available Key Dates (mostly `Apply by` date and
     * `Starting date` couples).
     *
     * Important: In case any significant changes are made to this component,
     * please re-test according to the https://victoriauniversity.atlassian.net/wiki/spaces/WT/pages/168198145/Blackbox+testing+guide+for+Topics+Programmes#BlackboxtestingguideforTopics&Programmes-Keydates
     *
     * @param {ng.IScope} $scope
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {LoggerService} LoggerFactory
     * @param {Utils} Utils
     * @param {Object} TEXTS
     */
    function KeyDatesController(
        $scope,
        ContentSwitchingService,
        LoggerFactory,
        Utils,
        TEXTS
    ){

        /** @type {ng.IController} */
        var vm = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'KeyDatesController', false );


        /** @const */
        var ATTRIBUTE_NAME_KEYDATES = 'keyDatesSet';





        /* ===== EXPOSE TO THE SCOPE ======================================== */


        $scope._     = TEXTS.SHARED.KEY_DATES;
        $scope.Utils = Utils;

        /** @constant */
        $scope.DATES_INLINE_COLLAPSE_LIMIT     = 3;





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        /** @type {{domestic:string, international:string}} */
        vm.datesModels = undefined;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        vm.$onInit = function() {
            initModel();
            setWatchers();

            // Full view or compact view?
            vm.isFullView = angular.isUndefined( vm.compactView );
        };

        /** *MUST BE* present to allow directive `collapsible` to bind to the Controller's $postLink event. */
        Utils.addGenericPostLinkTrigger( vm );





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function setWatchers() {
            $scope.$watch( 'ContentSwitchingService.contentType', function() {
                vm.isInternationalContent = ContentSwitchingService.isInternational();

                if ( vm.datesModels ) {
                    vm.dates = vm.datesModels[ vm.isInternationalContent ? 'international' : 'domestic' ];

                    if ( angular.isDefined( vm.limit ) ){
                        vm.dates = vm.dates.slice( 0, parseInt( vm.limit ) );
                    }
                }

                vm.onModelReady({ dates: vm.dates });
            });
        }


        /**
         * Initialises international and domestic key dates from qual's
         * (or subqual's) metadata (if they exist).
         */
        function initModel() {
            var keyDatesMetadata = Utils.retrieveMetadataRecursively( $scope, ATTRIBUTE_NAME_KEYDATES );

            // New KeyDate set compare and sort into domestic vs international
            if ( keyDatesMetadata ) {
                vm.datesModels = Utils.processKeyDates( keyDatesMetadata );
            } else {
                logger.error( "Cannot render Key Dates. Please, check that the `%s` attribute is included in the qualification's (or parental qualification's) `metadata`", ATTRIBUTE_NAME_KEYDATES );
            }
        }
    }


    KeyDatesController.$inject = [ '$scope', 'ContentSwitchingService', 'LoggerFactory', 'Utils', 'TEXTS' ];
})();
